import { render, staticRenderFns } from "./Sepet.vue?vue&type=template&id=ce2741d0&"
import script from "./Sepet.vue?vue&type=script&lang=js&"
export * from "./Sepet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports